import { isValid } from 'date-fns';

export class ValidDate extends Date {
  private type: 'ValidDate' = 'ValidDate';
}

export const is = (v: Date): v is ValidDate => isValid(v);
